module.exports = __webpack_public_path__ + "img/search_not_found_crop.ae9eae91.png";